import React ,{useState} from 'react'
import SubHeader from '../../../layout/components/SubHeader'
import ModernTabs from '../../../common/Tabs/ModernTabs'
import ClinicActivity from './ClinicActivity'
const Activity = () => {
    const [activeTab, setActiveTab] = useState('general');
    const handleTabClick = (tab) => {
      setActiveTab(tab);
    };
    const TabContent = [
        {
            id:'all',
            label:'All',
            icon:'bi-house-door',
            content: <ClinicActivity categoryValue="ALL"/>
        },
        {
            id:'Clinic_engagement',
            label:'Clinic Engagement',
            icon:'bi-clock',
            content: <ClinicActivity categoryValue="CLINIC_ENGAGEMENT"/>
        },
        {
            id:'Reminder',
            label:'Reminder',
            icon:'bi-clock',
            content: <ClinicActivity categoryValue="REMINDER"/>
        },
        {
            id:'Recall',
            label:'Recall',
            icon:'bi-clock',
            content: <ClinicActivity categoryValue="RECALL"/>
        },
        {
            id:'Lab',
            label:'Lab',
            icon:'bi-clock',
            content: <ClinicActivity categoryValue="LAB"/>
        },
        {
            id:'Summary',
            label:'Summary',
            icon:'bi-clock',
            content: <ClinicActivity categoryValue="SUMMARY"/>
        },
        {
            id:'Welcome',
            label:'Welcome',
            icon:'bi-clock',
            content: <ClinicActivity categoryValue="WELCOME"/>
        },
        {
            id:'Patient_Engagement',
            label:'Patient Engagement',
            icon:'bi-clock',
            content: <ClinicActivity categoryValue="PATIENT_ENGAGEMENT"/>
        },
        {
            id:'Post_exams',
            label:'Post Exams',
            icon:'bi-clock',
            content: <ClinicActivity categoryValue="POST_EXAMS"/>
        },
        {
            id:'Confirmation',
            label:'Confirmation',
            icon:'bi-clock',
            content: <ClinicActivity categoryValue="CONFIRMATION"/>
        },
    ]
    return (
        <>
            <SubHeader title="Activity" description="Detailed activity of the clinic" />
            <ModernTabs tabs={TabContent} orientation={"vertical"}/>
        </>
    )
}

export default Activity